/* eslint object-shorthand:0 no-var:0 */
const I18n = require('./dist/main.min.js').default;

module.exports = {
  I18n: I18n,
};
